export const tableOptions = {
  rowKey: "id", // 表格行的唯一标识符
  tableHeight: "calc(100vh - 400px)", // 表格高度
  tableBorder: true, // 是否显示表格边框
  pageSizes: [10, 20, 50, 100, 500, 1000, 2000],
  rowClickKey:"id",
  searchOrder: [
    "goShiftTime",
    "goShiftType",
    "projectInfoId",
    "goTruckCode",
    "tpMode",
    "landParcel",
    "status",
    "no",
    "inStaffName",
    "goStaffName",
    // "leadingNames",
    "fleetName",
    "captainFleetName",
    "garbageName",
    "goSoilType",
    "goRemark",
    "pcRemark",
    "inDatetime",
    // "isTicket",
    // "goTicketSoilType",
    "isEntrance",
    "carrierName",
    "settleType",
    "entranceTruckCode",
    "entranceStaffName",
    "entranceDatetime",
    "goVehicleType",
    "truckOwnerName",
    "goTime",
    "completeTime",
    "settleCardNo",
    // "isSetGarbagePreparePrice",
    "companySettleNo",
    "weightTons",
    "inSoilType",
    "ticketNo",
    // "ticketPrice",
    "isSettingGiveCardNo",
    "giveCardNo"
  ], // 搜索项排序
  columnOrder: [
    "projectInfoId",
    "tpMode",
    "landParcel",
    "status",
    "no",
    "goStaffName",
    "goSoilType",
    "garbageName",
    "goTruckCode",
    "goShiftTime",
    "goShiftType",
    "goDate",
    "goTime",
    "weightTons",
    "weightUnit",
    "payeePrice",
    "truckOwnerName",
    // 车队长
    "fleetCaptainName",
    "captainFleetName",
    "fleetName",
    "mobile",
    "inStaffName",
    "inSoilType",
    "inDatetime",
    "giveCardNo",
    "settleCardNo",
    // "goRemark",
    // "pcRemark",
    
   
    // "inStaffName",
    // "inDatetime",
    // "inSoilType",
    // "ticketNo",
    // "ticketPrice",
    // "payeePrice",
    // "settlePrice",
    // "createDatetime",
  ], // 列排序
  tableColumns: [
    {
      prop: "projectInfoId",
      label: "项目名称",
      width: 150,
      search: {
        multiple: true,
        splitSymbl:",",
        type: "select",
        placeholder: "请选择项目名称",
        dicUrl: "/chain/projectinfo/list", // 字典数据请求地址
        dicFormatter: (res) =>
          res.data.map((item) => ({ label: item.projectName, value: item.id })), // 格式化字典数据
      },
      formatter: (row) => {
        return row.projectInfoName;
      },
    },
    {
      prop: "landParcel",
      label: "地块",
      width: 120, 
      search: {
        type: "input",
        placeholder: "请输入地块", 
      },
    },
    {
      prop: "tpMode",
      label: "运输类型",
      splitSymbl:",",
      width: 120,
      search: {
        multiple: true,
        type: "select",
        splitSymbl:",",
        placeholder: "请选择运输类型",
        dicUrl:
          "/chain/systemdictionaryitem/listDictionaryItem?dictionary=tp_mode",
        dicFormatter: (res) =>
          res.data.map((item) => ({
            label: item.itemName,
            value: item.itemValue,
          })),
      },
      formatter: (row) => {
        return row.tpModeName;
      },
    },
    {
      prop: "status",
      label: "运单状态",
      width: 120,
      search: {
        multiple: true,
        splitSymbl:",",
        span: 12,
        type: "select",
        placeholder: "请选择运单状态",
        dicUrl:
          "/chain/systemdictionaryitem/listDictionaryItem?dictionary=waybill_status",
        dicFormatter: (res) =>
          res.data.map((item) => ({
            label: item.itemName,
            value: item.itemValue,
          })),
      },
      formatter: (row) => {
        return row.statusName;
      },
    },
    {
      prop: "no",
      label: "运单号",
      width: 200,
      search: {
        type: "input",
        placeholder: "请输入运单号",
      },
    },
    {
      prop: "goStaffName",
      label: "出场签单员",
      width: 120,
      search: {
        type: "input",
        placeholder: "请输入出场签单员",
      },
    },
    {
      prop: "goSoilType",
      label: "出场签单土质",
      width: 120,
      search: {
        multiple: true,
        splitSymbl:",",
        type: "select",
        placeholder: "请选择出场签单土质",
        dicUrl:
          "/chain/systemdictionaryitem/listDictionaryItem?dictionary=soil_type",
        dicFormatter: (res) =>
          res.data.map((item) => ({
            label: item.itemName,
            value: item.itemValue,
          })),
      },
    },
    {
      prop: "garbageName",
      label: "泥尾",
      width: 120,
      search: {
        type: "input",
        placeholder: "请输入泥尾",
      },
    },
    {
      prop: "goTruckCode", // 字段名
      label: "车牌号", // 列名
      width: 120, // 列宽
      search: {
        type: "input", // 搜索项类型
        placeholder: "请输入车牌号", // 占位符
      },
    },
    {
      prop: "goShiftTime",
      label: "班次日期",
      width: 120,
      search: {
        type: "daterange",
        placeholder: "请选择班次日期",
      },
    },
    {
      prop: "goShiftType",
      label: "出场班次",
      width: 120,
      search: {
        multiple: true,
        splitSymbl:",",
        type: "select",
        placeholder: "请选择出场班次",
        dicUrl: "/chain/projectinfo/getShiftOfProject",
        dicFormatter: (res) =>
          res.data.map((item) => ({ label: item, value: item })),
      },
    },
    {
      prop: "goDate",
      label: "出场签单日期",
      width: 120,
      searchHidden:true
    },
    {
      prop: "goTime",
      label: "出场签单时间",
      width: 150,
      search: {
        type: "datetimerange",
        placeholder: "请选择出场签单时间",
      },
    },
    {
      prop: "weightTons",
      label: "数量",
      width: 120,
      searchHidden:true
    },
    {
      prop: "weightUnit",
      label: "单位",
      width: 120,
      searchHidden:true
    },
    {
      prop: "payeePrice",
      label: "价格",
      width: 120,
      searchHidden:true
    },
    {
      prop: "truckOwnerName",
      label: "车辆所有人",
      width: 120,
      search: {
        type: "input",
        placeholder: "请输入车辆所有人",
      },
    },
    {
      prop: "fleetCaptainName",
      label: "车队长",
      width: 120,
      searchHidden:true
    },
    {
      prop: "captainFleetName",
      label: "车队名称",
      width: 120,
      search: {
        type: "input",
        placeholder: "请输入车队名称",
      },
    },
    {
      prop: "fleetName",
      label: "司机姓名",
      width: 120,
      searchHidden:true
    },
    {
      prop: "mobile",
      label: "司机手机号",
      width: 120,
      searchHidden:true
    },
    {
      prop: "inStaffName",
      label: "挖机签单员",
      width: 120,
      search: {
        type: "input",
        placeholder: "请输入挖机签单员",
      },
    },
    {
      prop: "inSoilType",
      label: "挖机签单土质",
      width: 120,
      searchHidden:true
    },
    {
      prop: "inDatetime",
      label: "挖机签单时间",
      width: 150,
      search: {
        type: "datetimerange",
        placeholder: "请选择挖机签单时间",
      },
    },
    {
      prop: "giveCardNo",
      label: "回执单号",
      width: 180,
      searchHidden:true
    },
    {
      prop: "settleCardNo",
      label: "电子结算卡",
      width: 130,
      search: {
        type: "input",
        placeholder: "请输入电子结算卡",
      },
    },
    
   
   
    // {
    //   prop: "leadingNames",
    //   label: "项目负责人",
    //   width: 120,
    //   hidden: true,
    //   search: {
    //     type: "input",
    //     placeholder: "请输入项目负责人",
    //   },
    // },
   
   
    {
      prop: "goRemark",
      label: "出场备注",
      width: 120,
      hidden:true,
      search: {
        type: "input",
        placeholder: "请输入出场备注",
      },
    },
    // {
    //   prop: "pcRemark",
    //   label: "PC后台备注",
    //   width: 120,
    //   hidden:true,
    //   search: {
    //     type: "input",
    //     placeholder: "请输入PC后台备注",
    //   },
    // },
    
    // {
    //   prop: "isTicket",
    //   label: "是否有泥尾票",
    //   hidden: true,
    //   width: 120,
    //   search: {
    //     type: "select",
    //     placeholder: "请选择是否有泥尾票",
    //     options: [
    //       {
    //         label: "否",
    //         value: "0",
    //       },
    //       {
    //         label: "是",
    //         value: "1",
    //       },
    //     ],
    //   },
    //   formatter: (row) => {
    //     return row.isTicket == 1 ? "是" : row.isTicket == 0 ? "否" : "";
    //   },
    // },
    // {
    //   prop: "goTicketSoilType",
    //   hidden: true,
    //   label: "泥尾票土质",
    //   width: 120,
    //   search: {
    //     type: "input",
    //     placeholder: "请输入泥尾票土质",
    //   },
    // },
    {
      prop: "isEntrance",
      label: "入场签单",
      width: 120,
      hidden: true,
      search: {
        type: "select",
        placeholder: "请选择入场签单",
        options: [
          {
            label: "否",
            value: "0",
          },
          {
            label: "是",
            value: "1",
          },
        ],
      },
    },
    {
      prop: "carrierName",
      label: "承运人",
      hidden: true,
      width: 120,
      search: {
        type: "input",
        placeholder: "请输入承运人",
      },
    },
    {
      prop: "settleType",
      label: "运单结算类型",
      hidden: true,
      width: 120,
      search: {
        type: "select",
        placeholder: "请选择运单结算类型",
        dicUrl:
          "/chain/systemdictionaryitem/listDictionaryItem?dictionary=settle_type",
        dicFormatter: (res) =>
          res.data.map((item) => ({
            label: item.itemName,
            value: item.itemValue,
          })),
      },
    },
    {
      prop: "entranceTruckCode",
      label: "入场签单车牌",
      width: 120,
      hidden: true,
      search: {
        type: "input",
        placeholder: "请输入入场签单车牌",
      },
    },
    {
      prop: "entranceStaffName",
      label: "入场签单人",
      hidden: true,
      width: 120,
      search: {
        type: "input",
        placeholder: "请输入入场签单人",
      },
    },

    {
      prop: "entranceDatetime",
      label: "入场签单时间",
      hidden: true,
      width: 150,
      search: {
        type: "datetimerange",
        placeholder: "请选择入场签单时间",
      },
    },

    {
      prop: "goVehicleType",
      label: "出口签单车型",
      hidden: true,
      width: 120,
      search: {
        type: "select",
        placeholder: "请选择出口签单车型",
        dicUrl:
          "/chain/systemdictionaryitem/listDictionaryItem?dictionary=go_vehicle_type",
        dicFormatter: (res) =>
          res.data.map((item) => ({
            label: item.itemName,
            value: item.itemValue,
          })),
      },
    },
   
    
    {
      prop: "completeTime",
      label: "完成时间",
      hidden: true,
      width: 150,
      search: {
        type: "datetimerange",
        placeholder: "请选择完成时间",
      },
    },
   
    // {
    //   prop: "isSetGarbagePreparePrice",
    //   label: "泥尾价",
    //   hidden: true,
    //   width: 120,
    //   search: {
    //     type: "select",
    //     placeholder: "请选择泥尾价",
    //     options: [
    //       {
    //         label: "未设置",
    //         value: "0",
    //       },
    //       {
    //         label: "已设置",
    //         value: "1",
    //       },
    //     ],
    //   },
    // },
    {
      prop: "companySettleNo",
      label: "结算单号",
      hidden: true,
      width: 120,
      search: {
        type: "input",
        placeholder: "请输入结算单号",
      },
    },
    {
      prop: "isSettingGiveCardNo",
      label: "是否交卡",
      hidden: true,
      width: 120,
      search: {
        type: "select",
        placeholder: "请选择是否交卡",
        options: [
          {
            label: "已交卡",
            value: "1",
          },
          {
            label: "未交卡",
            value: "0",
          },
        ],
      },
    }
  ],
};
